// src/screens/Eula.js
import React from "react";
import "../styles/LegalPage.css";

export default function Eula() {
  return (
    <div className="legal-page">
      <div className="legal-card">
        <h1>Pay2Pee End User License Agreement (EULA)</h1>
        <p className="legal-meta">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <p>
          This End User License Agreement (&quot;EULA&quot;) is a legal
          agreement between you (&quot;you&quot; or &quot;User&quot;) and
          Pay2Pee LLC (&quot;Company,&quot; &quot;we,&quot; &quot;us&quot;).
          This EULA governs your use of the Pay2Pee mobile application
          (&quot;App&quot;).
        </p>

        <p>
          By installing or using the App, you agree to be bound by this EULA. If
          you do not agree, do not install or use the App.
        </p>

        <h2>1. License Grant</h2>
        <p>
          We grant you a limited, revocable, non-exclusive, non-transferable
          license to download, install, and use the App for your personal,
          non-commercial use, subject to this EULA and our Terms of Service.
        </p>

        <h2>2. Ownership</h2>
        <p>
          The App, including all content, code, designs, and trademarks, is
          owned by Pay2Pee LLC and is protected by intellectual property laws.
          This EULA does not transfer ownership to you.
        </p>

        <h2>3. Restrictions</h2>
        <p>You agree that you will not:</p>
        <ul>
          <li>Copy, modify, or create derivative works of the App</li>
          <li>Reverse-engineer, decompile, or disassemble the App</li>
          <li>
            Distribute, sell, sublicense, rent, or lease the App to third
            parties
          </li>
          <li>
            Use the App for any unlawful purpose or in violation of any
            applicable laws
          </li>
        </ul>

        <h2>4. Third-Party Services</h2>
        <p>
          The App may use third-party services such as Stripe, Firebase, and
          Google Maps. Your use of those services may be governed by additional
          terms and privacy policies provided by those third parties.
        </p>

        <h2>5. Updates and Changes</h2>
        <p>
          We may update or modify the App from time to time to improve
          performance, add features, fix bugs, or enhance security. These
          updates may be installed automatically.
        </p>

        <h2>6. Termination</h2>
        <p>
          This EULA is effective until terminated. We may terminate your license
          and access to the App at any time if you violate this EULA, our Terms
          of Service, or any applicable law. Upon termination, you must stop
          using the App and delete it from your devices.
        </p>

        <h2>7. Disclaimer of Warranties</h2>
        <p>
          The App is provided on an &quot;AS IS&quot; and &quot;AS AVAILABLE&quot; basis, without warranties
          of any kind, express or implied, including but not limited to
          warranties of merchantability, fitness for a particular purpose, and
          non-infringement.
        </p>

        <h2>8. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, Pay2Pee LLC will not be liable
          for any indirect, incidental, special, consequential, or punitive
          damages, or any loss of profits, revenue, data, or use, arising out of
          or related to your use of the App.
        </p>

        <h2>9. Governing Law</h2>
        <p>
          This EULA is governed by the laws of the United States and, where
          applicable, the state in which you reside, without regard to conflict
          of laws principles.
        </p>

        <h2>10. Contact</h2>
        <p>
          If you have questions about this EULA, please contact us at{" "}
          <a href="mailto:support@pay2pee.app">support@pay2pee.app</a>.
        </p>
      </div>
    </div>
  );
}
